/**
 * Copyright (c) 2010-2024 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { environment } from './environment';

let local = {};

try {
    local = require('./environment.local').default;
} catch (e) {
    window.console.debug(e);
    // ignore errors since file may not exists
}

export const env = {...environment, ...local};

